import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Dropdown, Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from "react-datepicker";

import { ThemeContext } from "../../../../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { AddInvoiceApi } from "../../../../service/bankApi/addInvoice";
import { toast, ToastContainer } from "react-toastify";
import { getInvoicesType } from "../../../../service/bankApi/getInvoiceTypes";
import Select from "react-select";
import AutohideToaster from "../../Toaster/Toaster";
import VerificationTable from "./verificationTable";
import { getPropertyListApi } from "../../../../service/property/propertyList"
import { getVendorByPropIdApi } from "../../../../service/property/getVendorByProp";
import { getInvoiceByIdApi } from "../../../../service/bankApi/getInvocieById";
import { setLoading } from "../../../../feature/authSlice";
const VerificationScreen = () => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { changeBackground } = useContext(ThemeContext);
  const[propertiesList,setPropertiesList] = useState([])
  const[selectedPropertyId,setSelectedPropertyId] = useState({

  })
  const [selectedField,setSelectedField] = useState({})


  // useEffect(()=>{
  //   var data ={
  //     Id :parseInt(localStorage.getItem("invoiceId"))
  //   }


  //   dispatch(getInvoiceByIdApi(data,()=>{},()=>{}))
  // },[])

  const columns = [
    {
      Header: "",
      Footer: "Action",
      accessor: "Action",
    },
    {
      Header: "Particular",
      Footer: "Amount",
      accessor: "Particulars" || "particulars",
    },
    {
      Header: "HSN",
      Footer: "Invoice due date",
      accessor: "HSN",
    },
    {
      Header: "Floor",
      Footer: "Floor",
      accessor: "Floor",
    },
    {
      Header: "Unit",
      Footer: "Unit",
      accessor: "Unit",
    },
    {
      Header: "Area",
      Footer: "Area",
      accessor: "Area",
    },
    {
      Header: "Quantity",
      Footer: "qty",
      accessor: "qty",
    },
    {
      Header: "Rate",
      Footer: "Rate",
      accessor: "Rate",
    },
    {
      Header: "Amount",
      Footer: "Amount",
      accessor: "Amount",
    },






  ];
  const notifyTopRight = () => {
    toast.success("✔️ Submit Successfully !!!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyTopRightError = (err) => {
    toast.error(err, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };


  var data = localStorage.getItem("verifyObject");
  if (data) {
    var value = JSON.parse(data);
  }
  // console.log(value.Value.PropertyId);
  
  const [valuesObj, setValuesObj] = useState(value?.Value)
  const [tableArr, setTableArr] = useState(value.TablesValues)
  const [amount, setAmount] = useState(value.Value.Amount);
  const [customerAddress, setCustomerAddress] = useState(
    value.Value.CustomerAddress
  );

  const [customerName, setCustomerName] = useState(value.Value.CustomerName);
  const [invoiceDate, setInvoiceDate] = useState(value.Value.InvoiceDate);
  const [invoiceDueDate, setInvoiceDueDate] = useState(
    value.Value.InvoiceDueDate
  );
  const [invoiceNumber, setInvoiceNumber] = useState(value.Value.InvoiceNo);
  const [leaseNumber, setLeaseNumber] = useState(value.Value.LeaseNo);
  const [RecieverGstin, setRecieverGstin] = useState(value.Value.ReceiverGstin);
  const [supplierAddress, setSupplierAddress] = useState(
    value.Value.SupplierAddress
  );
  const [supplierGstin, setSupplierGstin] = useState(value.Value.SupplierGstin);
  const [supplierName, setSupplierName] = useState(value.Value.SupplierName);
  const [totalAmount, setTotalAmount] = useState(value.Value.TotalAmount);
  const [totalTaxValue, setTotalTaxValue] = useState(value.Value.TotalTaxValue);
  const [invoiceDateError, setInvoiceDateError] = useState(false);
  const [invoiceDueDateError, setInvoiceDueDateError] = useState(false);
  const [invoiceNumberError, setInvoiceNumberError] = useState(false);
  const [leaseNumberError, setLeaseNumberError] = useState(false);
  const [customerNameError, setCustomerNameError] = useState(false);
  const [customerAddressError, setCustomerAddressError] = useState(false);
  const [supplierNameError, setSupplierNameError] = useState(false);
  const [supplierAddressError, setSupplierAddressError] = useState(false);
  const [supplierGstinError, setSupplierGstinError] = useState(false);
  const [RecieverGstinError, setRecieverGstinError] = useState(false);
  const [totalAmountError, setTotalAmountError] = useState(false);
  const [totalTaxValueError, setTotalTaxValueError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileId, setFileId] = useState(value.Value.FileId);
  const [invoiceType, setInvoiceType] = useState();
  const [invoiceTypeArr, setInvoiceTypeArr] = useState([]);
  const [selectInvoiceTypeError, setSelectInvoiceTypeError] = useState(false)
  const [actionMessage, setActionMessage] = useState(false)
  const [message, setMessage] = useState("")
  const [toaster, setToaster] = useState(false)
  const [updatedArray, setUpdatedArray] = useState([])
  const [selectPropertyIdTypeError,setSelectPropertyIdTypeError] = useState(false)
  const [selectedVendorField,setSelectedVendorFeild] = useState({
    value:"",
    label:"Select Vendor"
  })

  const[selectedVendorId,setSelectedVendorId] = useState()
  const [vendorList,setVendorList] = useState([])
  const [selectVendorError,setSelectVendorError] = useState(false)

const [locationCode,setLocationCode]=useState('')

  useEffect(() => {
  
    var data = {

      Filter: "status==3",
      OrderBy: "AddressLine1",
      PageSize: 1000,
      PageNumber: 1

    }
    dispatch(getPropertyListApi(data, (res) => { 
      
   
      setPropertiesList(res.data.result.properties)
      // matchId(res.data?.result?.properties)
     
      // console.log(res.data)
     }, (err) => { console.log(err) }))
  }, [])

  useEffect(()=>{
    matchId()
  },[propertiesList])

  // function matchId (){
  
  //   const matchedIndex = propertiesList.findIndex(address => address.AddressLine1 === supplierAddress);

  //   if(matchedIndex != -1){
  //     setSelectedField({
  //       value:propertiesList[matchedIndex].Id,
  //       label:propertiesList[matchedIndex].AddressLine1 + " "+ propertiesList[matchedIndex].AddressLine2 + " " +propertiesList[matchedIndex].AddressLine3
  //     })
  //     setSelectedPropertyId(propertiesList[matchedIndex].Id)
  //   }else{
  //     setSelectedPropertyId(0)
  //     setSelectedField({
  //       value:"",
  //       label:"Select Property"
  //     })
  //   }
  // }

  // function matchId() {
  //   console.log(value.Value.PropertyId)
  //   const similarityThreshold = 75; // Similarity threshold percentage
  
  //   const compareAddresses = (addressA, addressB) => {
  //     if (!addressA || !addressB) return false;
  
  //     // Step 1: Replace commas with spaces and convert to lowercase
  //     addressA = addressA.replace(/,/g, ' ').toLowerCase();
  //     addressB = addressB.replace(/,/g, ' ').toLowerCase();
  
  //     // Step 2: Convert strings to arrays of words
  //     const addressAArray = addressA.split(/\s+/).filter(Boolean);
  //     const addressBArray = addressB.split(/\s+/).filter(Boolean);
  
  //     // Step 3: Count common words
  //     const commonWordsCount = addressAArray.filter(word => addressBArray.includes(word)).length;
  
  //     // Step 4: Calculate percentage of similarity
  //     const similarityPercentage = (commonWordsCount / addressAArray.length) * 100;
  
  //     // Step 5: Check if similarity percentage is greater than 75%
  //     return similarityPercentage > similarityThreshold;
  //   };
  
  //   const matchedIndex = propertiesList.findIndex(address => 
  //     compareAddresses( address.FullAddress,customerAddress)
  //   );
  // console.log(matchedIndex)
  //   if (matchedIndex !== -1) {
  //     setSelectedField({
  //       value: propertiesList[matchedIndex].Id,
  //       label: propertiesList[matchedIndex].AddressLine1 + " " + 
  //              propertiesList[matchedIndex].AddressLine2 + " " + 
  //              propertiesList[matchedIndex].AddressLine3
  //     });
  //     setSelectedPropertyId(propertiesList[matchedIndex].Id);
  //   } else {
  //     setSelectedPropertyId(0);
  //     setSelectedField({
  //       value: "",
  //       label: "Select Property"
  //     });
  //   }
  // }
  function matchId() {
    // console.log(value)
    const similarityThreshold = 75; // Similarity threshold percentage
  
    const compareAddresses = (addressA, addressB) => {
      if (!addressA || !addressB) return false;
  
      // Step 1: Replace commas with spaces and convert to lowercase
      addressA = addressA.replace(/,/g, ' ').toLowerCase();
      addressB = addressB.replace(/,/g, ' ').toLowerCase();
  
      // Step 2: Convert strings to arrays of words
      const addressAArray = addressA.split(/\s+/).filter(Boolean);
      const addressBArray = addressB.split(/\s+/).filter(Boolean);
  
      // Step 3: Count common words
      const commonWordsCount = addressAArray.filter(word => addressBArray.includes(word)).length;
  
      // Step 4: Calculate percentage of similarity
      const similarityPercentage = (commonWordsCount / addressAArray.length) * 100;
  
      // Step 5: Check if similarity percentage is greater than 75%
      return similarityPercentage > similarityThreshold;
    };

// console.log(value.Value.PropertyId)
    
    // // First, check if value.value.PropertyId exists
    // if (value.Value && value.Value.PropertyId) {
    //   const matchedProperty = propertiesList.find(property => property.Id === value.Value.PropertyId);
    //   if (matchedProperty) {
    //     setSelectedField({
    //       value: matchedProperty.Id,
    //       label: matchedProperty.AddressLine1 + " " +
    //              matchedProperty.AddressLine2 + " " +
    //              matchedProperty.AddressLine3
    //     });
    //     setSelectedPropertyId(matchedProperty.Id);
    //     setLocationCode(matchedProperty.LocationCode)
    //     return; // Exit function early if matched by PropertyId
    //   }

    // }
  
    // If no PropertyId match, perform address comparison
    // const matchedIndex = propertiesList.findIndex(address =>
    //   compareAddresses(address.AddressToCompare, value.Value.PremisesAddress)
    // );
    
  // console.log("matchedIndex",matchedIndex)
      const matchedIndex = propertiesList.findIndex(address =>
      address.AddressToCompare === value.Value.PremisesAddress
    );
    // console.log("matchedIndex",matchedIndex)
    if (matchedIndex !== -1) {
      // console.log("propertiesList[matchedIndex].Id",propertiesList[matchedIndex].Id)
      setSelectedField({
        value: propertiesList[matchedIndex].Id,
        label: propertiesList[matchedIndex].AddressLine1 + " " +
               propertiesList[matchedIndex].AddressLine2 + " " +
               propertiesList[matchedIndex].AddressLine3
      });
      setSelectedPropertyId(propertiesList[matchedIndex].Id);
      setLocationCode(propertiesList[matchedIndex].LocationCode)
      // console.log(propertiesList[matchedIndex].Id)
    } else {
      setSelectedPropertyId(0);
      setSelectedField({
        value: "",
        label: "Select Property"
      });
    }
  }
  

  useEffect(() => {
    handleUpdatedArr(value.TablesValues)
    dispatch(
      getInvoicesType({}, (res) => {
        setInvoiceTypeArr(res.data.result);

      })
    );

 
  }, []);

  useEffect(()=>{
setSelectedVendorFeild({
  value:"",
  label:"Select Vendor"
})
    loadVendorArr()
  },[selectedPropertyId])

  function loadVendorArr (){
 
  var data = {
    propertyId:PropertyId || selectedPropertyId
  }

  dispatch(getVendorByPropIdApi(data,(res)=>{
    setVendorList(res.data.result)
    // console.log(res,"Vendoe Dara")
  },(err)=>{console.log(err)}))

  }
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

 
  const numberOnChange = (number) => {
    if (!isNaN(Number(number))) {
      return true;
    } else {
      return false;
    }
  };
  function convertValue(e) {
    // Parse the string to a Date object
    const originalDate = new Date(e);

    // Extract the components of the date
    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, "0"); // months are zero-based
    const day = String(originalDate.getDate()).padStart(2, "0");
    const hours = String(originalDate.getHours()).padStart(2, "0");
    const minutes = String(originalDate.getMinutes()).padStart(2, "0");
    const seconds = String(originalDate.getSeconds()).padStart(2, "0");
    const milliseconds = String(originalDate.getMilliseconds()).padStart(
      7,
      "0"
    );

    // Get the timezone offset in minutes, then convert to hours and minutes
    const offsetInMinutes = originalDate.getTimezoneOffset();
    const offsetHours = String(
      Math.abs(Math.floor(offsetInMinutes / 60))
    ).padStart(2, "0");
    const offsetMinutes = String(Math.abs(offsetInMinutes % 60)).padStart(
      2,
      "0"
    );
    const offsetSign = offsetInMinutes <= 0 ? "+" : "-";
    const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

    // Format to desired ISO 8601-like string with milliseconds and timezone
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;
    return formattedDate;
  }

  function handleChangeInvoiceData(e) {
    const dataVal = convertValue(e);
    setInvoiceDate(dataVal);
  }

  function handleChangeInvoiceDueData(e) {
    const dataVal = convertValue(e);
    setInvoiceDueDate(dataVal);
  }

  function validateForm() {
    if (
      supplierGstin === "" ||
      supplierGstin === null ||
      RecieverGstin === "" ||
      RecieverGstin === null ||
      totalTaxValue === "" ||
      totalTaxValue === null ||
      totalAmount === "" ||
      totalAmount === null ||
      amount === "" ||
      amount === null ||
      amount == 0 ||
      invoiceDueDate === "" ||
      invoiceDueDate === null ||
      invoiceDate === "" ||
      invoiceDate === null ||
      invoiceNumber === "" ||
      invoiceNumber === null ||
      customerName === "" ||
      customerName === null ||
      customerAddress === "" ||
      customerAddress === null ||
      supplierName === "" ||
      supplierName === null ||
      supplierAddress === "" ||
      supplierAddress === null ||
      selectedPropertyId === 0 || selectedPropertyId === null ||
      selectedVendorId === 0 || selectedVendorId === null || selectedVendorId === undefined
    ) {

      return false; // At least one condition is not satisfied
    }

    return true; // All conditions are satisfied
  }

  function handleSave() {
    if (selectedOption !== null) {
      const validate = validateForm();
      if (!validate) {
        if (supplierGstin == "" || supplierGstin == null) {
          setSupplierGstinError(true);
        }
        if (RecieverGstin == "" || RecieverGstin == null) {
          setRecieverGstinError(true);
        }

        if (totalTaxValue === "" || totalTaxValue == null) {
          setTotalTaxValueError(true);
        }
        if (totalAmount === "" || totalAmount == null) {
          setTotalAmountError(true);
        }

        if (amount === "" || amount == null || amount == 0) {
          setAmountError(true);
        }
        if (invoiceDueDate == "" || invoiceDueDate == null) {
          setInvoiceDueDateError(true);
        }
        if (invoiceDate == "" || invoiceDate == null) {
          setInvoiceDateError(true);
        }
        if (invoiceNumber == "" || invoiceNumber == null) {
          setInvoiceNumberError(true);
        }

        if (customerName == "" || customerName == null) {
          setCustomerNameError(true);
        }
        if (customerAddress == "" || customerAddress == null) {
          setCustomerAddressError(true);
        }

        if (supplierName == "" || supplierName == null) {
          setSupplierNameError(true);
        }

        if (supplierAddress == "" || supplierAddress == null) {
          setSupplierAddressError(true);
        }

        if(selectedPropertyId == 0 || selectedPropertyId === null){
          setSelectPropertyIdTypeError(true)
        } 
        if(selectedVendorId == null || selectedVendorId == undefined){
        setSelectVendorError(true)
        }
        notifyTopRightError("Please enter valid details in form !!!")
      } else {
        dispatch(setLoading(true))
        setIsLoading(true);
        var dataValue = {
          SupplierGstin: supplierGstin,
          ReceiverGstin: RecieverGstin,
          TotalTaxValue: totalTaxValue,
          TotalAmount: totalAmount,
          Amount: amount,
          InvoiceDueDate: invoiceDueDate,
          InvoiceDate: invoiceDate,
          InvoiceNo: invoiceNumber,
          LeaseNo: leaseNumber,
          CustomerName: customerName,
          CustomerAddress: customerAddress,
          SupplierName: supplierName,
          SupplierAddress: supplierAddress,
          FileId: fileId,
          InvoiceType: selectedOption.label,
          CustomerId: customerId,
          PropertyId: selectedPropertyId,
          Status: 0,
          InvoiceDetails: updatedArray.length == 0 ? tableArr : updatedArray,
          VendorId:selectedVendorId,
          PremisesAddress:value?.Value?.PremisesAddress
        };

        dispatch(
          AddInvoiceApi(
            dataValue,
            (res) => {
              dispatch(setLoading(false))
              notifyTopRight();
              setIsLoading(false);
            setTimeout(()=>{
              navigate("/invoiceVerification")
            },2000)
            },
            (err) => {
              dispatch(setLoading(false))
              // notifyTopRightError(err.data.error.exceptionMessage)
              setIsLoading(false);
            }
          )
        );
      }
      // if(false){

      // }
    } else {
      notifyTopRightError("Please enter valid details in form !!!")
      setSelectInvoiceTypeError(true)
    }

  }
  const [selectedOption, setSelectedOption] = useState(null);
 

  function handleValueSelected(e) {
    setSelectInvoiceTypeError(false)
    setSelectedOption(e);

  }

  function handleOnChangeSelectedProperty (e){
    setSelectPropertyIdTypeError(false)
setSelectedField(e)
setSelectedPropertyId(e.value)
const matchedIndex = propertiesList.findIndex(address => address.Id === e.value);
if(propertiesList[matchedIndex].LocationCode!==null){
  setLocationCode(propertiesList[matchedIndex].LocationCode)
}else{
  setLocationCode('')
}
// console.log(propertiesList[matchedIndex].LocationCode)


  }
  function handlAddArray() {
    var value = {
      Amount: "",
      Area: "",
      BillingCycleFrom: "",
      BillingCycleTo: "",
      CGST: "",
      CGSTAmount: "",
      ConsumptionUnits: "",
      DifferenceUnits: "",
      FileId: 0,
      Floor: "",
      HSN: "",
      Id: "",
      MeterNo: "",
      MeterReadingCurrent: "",
      MeterReadingPrevious: "",
      Particulars: "",
      Qty: "",
      Rate: "",
      SGST: "",
      SGSTAmount: "",
      Unit: ""
    };
    setTableArr([...tableArr, value])
    toast.success("New row added", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });

  }



  function handleUpdatedArr(data) {
    setTableArr(data)
    const updatedData = data.map(item => {
      const { Id, Invoice, ...rest } = item;
      return rest;
    });
    setUpdatedArray(updatedData)
  }
  function handleOnChangeSelectedVendor (e){
    setSelectVendorError(false)
setSelectedVendorFeild(e)
setSelectedVendorId(e.value)
  }

  const datePickerRef = useRef(null);
  const datePickerDueRef = useRef(null);


  const openDatePicker = (ref) => {
    if (ref.current) {
      ref.current.setOpen(true);
    }
  };

  return (
    <>
      <ToastContainer />
      {/* {  toaster && <AutohideToaster action={actionMessage} message={message} handleFucntion={()=>{setToaster(false)}}/>} */}
      <div className="row d-flex justify-content-between">
        {/* <BalanceCardSlider /> */}
        <div className="col-xl-6">
          <div className="card h-auto">
            <div
              className="card-body px-0 pt-1"
              style={{ maxHeight: "741px", overflowY: "auto" }}
            >
              <Tab.Container defaultActiveKey="Form">

                <div className="card-header border-0 pb-2 flex-wrap">
                  <div className="d-flex">
                  <i className="material-icons" style={{cursor:'pointer',marginRight:'12px',marginTop:'1px'}} onClick={()=>window.history.go(-1)}>chevron_left</i> 
                  <h4 className="heading me-2"> Verification</h4>
                  </div>
                  <nav>
                    <Nav as="div" className="order nav nav-tabs" role="tablist">
                      <Nav.Link
                        as="button"
                        eventKey="Form"
                      // onClick={() => {
                      //   setOpenTab(1);
                      // }}
                      >
                        Form
                      </Nav.Link>
                    {tableArr.length > 0 &&  <Nav.Link
                        as="button"
                        eventKey="Table"
                      // onClick={() => {
                      //   setOpenTab(2);
                      // }}
                      >
                        Table
                      </Nav.Link>}
                    </Nav>
                  </nav>
                </div>
                <div className="">
                  <Tab.Content>

                    <Tab.Pane eventKey="Form">
                      <Tab.Container >

                        <div className="sell-element">
                          <div className=" col-lg-12">

                            <button
                              className="btn btn-primary"
                              style={{
                                background: "rgba(233, 133, 35, 0.84)",
                                border: "none",
                              }}
                              onClick={() => {
                                handleSave();
                              }}
                            >
                              {isLoading ? "Submitting..." : "Submit"}
                            </button>

                            <div className="card-body">
                              <div className="basic-form">
                                <form onSubmit={(e) => e.preventDefault()}>

                                <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Property
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        value={selectedField}
                                        onChange={handleOnChangeSelectedProperty}
                                        placeholder="Select Property Type" 
                                        options={propertiesList.map(item => ({
                                          value: item.Id,
                                          label: item.LocationName===null?"":item.LocationName+" - "+item.AddressLine1 + " "+ item.AddressLine2 + " " +item.AddressLine3
                                        }))}

                                      />
                                      {selectPropertyIdTypeError && (
                                        <p className="text-danger">
                                        Please select property
                                        </p>
                                      )}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Vendor
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        value={selectedVendorField}
                                        onChange={handleOnChangeSelectedVendor}
                                        placeholder="Select Invoice Type"
                                        options={vendorList.map(item => ({
                                          value: item.Id,
                                          label: item.VendorName  + " " + "("+item.VendorGSTIN +")"
                                        }))}

                                      />
                                      {selectVendorError && (
                                        <p className="text-danger">
                                        Please select vendor
                                        </p>
                                      )}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice Type
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        value={selectedOption}
                                        onChange={handleValueSelected}
                                        placeholder="Select Invoice Type"
                                        options={invoiceTypeArr.map(item => ({
                                          value: item.Id,
                                          label: item.Name
                                        }))}

                                      />
                                      {selectInvoiceTypeError && (
                                        <p className="text-danger">
                                          Please select invoice type
                                        </p>
                                      )}

                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice Number
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={invoiceNumber}
                                        onChange={(e) => {
                                          setInvoiceNumberError(false);
                                          setInvoiceNumber(e.target.value);
                                        }}
                                      />
                                      {invoiceNumberError && (
                                        <p className="text-danger">
                                          Please enter valid invoice number
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                                ref={datePickerRef}
                                        className="form-control"
                                        value={invoiceDate?.split("T")[0]}
                                        onChange={(e) => {
                                          handleChangeInvoiceData(e);
                                          setInvoiceDateError(false);
                                        }}
                                      />
                                      {invoiceDateError && (
                                        <p className="text-danger">
                                          Please enter valid invoice date
                                        </p>
                                      )}
                                    </div>
                                    <div className="col-sm-1"   onClick={() => openDatePicker(datePickerRef)}  style={{ cursor: "pointer" }}>
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice due date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                                  ref={datePickerDueRef}
                                        className="form-control"
                                        value={invoiceDueDate?.split("T")[0]}
                                        onChange={(e) => {
                                          handleChangeInvoiceDueData(e);
                                          setInvoiceDueDateError(false);
                                        }}
                                      />
                                      {invoiceDueDateError && (
                                        <p className="text-danger">
                                          Please enter valid invoice due date
                                        </p>
                                      )}
                                    </div>
                                    <div className="col-sm-1"  onClick={() => openDatePicker(datePickerDueRef)}>
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  {/* 2 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer Name
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={customerName}
                                        onChange={(e) => {
                                          setCustomerName(e.target.value);
                                          setCustomerNameError(false);
                                        }}
                                      />
                                      {customerNameError && (
                                        <p className="text-danger">
                                          Please enter valid customer name
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  {/* 3 */}

                                  {/* 4 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer Address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={customerAddress}
                                        onChange={(e) => {
                                          setCustomerAddress(e.target.value);
                                          setCustomerAddressError(false);
                                        }}
                                      ></textarea>
                                      {customerAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid customer address
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Location Code
                                    </label>
                                    <div className="col-sm-9">
                                    <input
                                    disabled
                                        className="form-control"
                                        value={locationCode}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer GSTIN
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={RecieverGstin}
                                        onChange={(e) => {
                                          setRecieverGstinError(false);
                                          setRecieverGstin(e.target.value);
                                        }}
                                      />
                                      {RecieverGstinError && (
                                        <p className="text-danger">
                                          Please enter valid reciever gstin
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 5 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier Name
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={supplierName}
                                        onChange={(e) => {
                                          setSupplierNameError(false);
                                          setSupplierName(e.target.value);
                                        }}
                                      />
                                      {supplierNameError && (
                                        <p className="text-danger">
                                          Please enter valid supplier name
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={supplierAddress}
                                        onChange={(e) => {
                                          setSupplierAddressError(false);
                                          setSupplierAddress(e.target.value);
                                        }}
                                      ></textarea>
                                      {supplierAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier address
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  {/* 6 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier GSTIN
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={supplierGstin}
                                        onChange={(e) => {
                                          setSupplierGstinError(false);
                                          setSupplierGstin(e.target.value);
                                        }}
                                      />
                                      {supplierGstinError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier gstin
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 7 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={amount}
                                        onChange={(e) => {
                                          numberOnChange(e.target.value) &&
                                            setAmount(e.target.value);
                                          setAmountError(false);
                                        }}
                                      />
                                      {amountError && (
                                        <p className="text-danger">
                                          Please enter valid amount
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 8 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Tax Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={totalTaxValue}
                                        onChange={(e) => {
                                          numberOnChange(e.target.value) &&
                                            setTotalTaxValue(e.target.value);
                                          setTotalTaxValueError(false);
                                        }}
                                      />
                                      {totalTaxValueError && (
                                        <p className="text-danger">
                                          Please enter valid total tax value
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 9 */}

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Total Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={totalAmount}
                                        onChange={(e) => {
                                          numberOnChange(e.target.value) &&
                                            setTotalAmount(e.target.value);
                                          setTotalAmountError(false);
                                        }}
                                      />
                                      {totalAmountError && (
                                        <p className="text-danger">
                                          Please enter valid total amount
                                        </p>
                                      )}
                                    </div>
                                  </div>



                                  {/* 
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label">
                                      Lease no
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={leaseNumber}
                                        onChange={(e) => {
                                          setLeaseNumber(e.target.value);
                                          setLeaseNumberError(false);
                                        }}
                                      />
                                      {leaseNumberError && (
                                        <p className="text-danger">
                                          Please enter valid lease number
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                 
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label">
                                      Supplier address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={supplierAddress}
                                        onChange={(e) => {
                                          setSupplierAddressError(false);
                                          setSupplierAddress(e.target.value);
                                        }}
                                      ></textarea>
                                      {supplierAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier address
                                        </p>
                                      )}
                                    </div>
                                  </div> */}

                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Container>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Table">
                      <Tab.Container >
                        <Tab.Content id="nav-tabContent1">

                        </Tab.Content>
                        <VerificationTable column={columns} rowsArr={tableArr} addNewRow={() => { handlAddArray() }} updatedArray={handleUpdatedArr} handleSave={handleSave} isLoading={isLoading} buttonLoading={"Submitting"} buttonName={"Submit"} />
                      </Tab.Container>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card h-auto">
            <div className="card-body px-0 pt-1" style={{ overflowY: "auto" }}>
              <Tab.Container defaultActiveKey="Navbuy">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="Navbuy">
                      <iframe
                        src={value?.FilePath}
                        width="100%"
                        height={"700px"}
                      ></iframe>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerificationScreen;
